import {createSelector} from "@reduxjs/toolkit";
import {CommonState} from "..";
import {combine} from "../../utils";
import {InitialState} from "./types";
import {selectOrganisationByAlias} from "../organisation/selectots";

export const selectUserReducer = (state: CommonState): InitialState => state.user;
export const selectUserName = (state: CommonState) => combine(selectUserReducer, (userState: InitialState) => userState.name)(state); 

export const selectUserOrganisation = (state: CommonState) => combine(
    selectUserReducer,
    (userState: InitialState) => {
        const alias = userState.organisation;
        return selectOrganisationByAlias(state, alias ? String(alias) : '');
    }
)(state);
export const selectUserRoles = createSelector(
    [
        (state: CommonState) => selectUserReducer(state),
    ],
    (userState: InitialState) => {
        return userState?.role || [];
    }
);